type Language = (typeof LANGUAGES)[number];

const LANGUAGES = ['ja', 'en'] as const;

const LANGUAGE_LABELS = {
  ja: '日本語',
  en: 'English',
} as const satisfies Record<Language, string>;

export type { Language };
export { LANGUAGES, LANGUAGE_LABELS };
